import dayjs from 'dayjs'
// import { STORAGE_NUM, LOAD_AND_UNLOAD_NUM, LEASING_STORAGE_NUM } from '../../../constant/constant.js'
import { companyAdvanceConfig, siteAdvanceConfig, logicalWhAdvanceConfig } from '../../../constant/advanceConfig.js'

export default {
    // configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '月份',
                value: 'assessmentMonthList',
                type: 'time',
                timeType: 'monthrange',
                format: 'yyyy-MM',
                startPlaceholder: '开始月份',
                endPlaceholder: '结束月份',
                unfold: true,
                span: 5,
            },
            {
                name: '供应商',
                value: 'supplierName',
                advanceLabel: '供应商弹出框',
                type: 'advance',
                multiple: true,
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                cbParams: [
                    'supplierCode#supplierCode',
                    'supplierNameCn#supplierName',
                    // 'supplierType#supplierType',
                    // 'propertyNature#property',
                ],
                multipleTableColumn: { prop: 'supplierNameCn', value: '供应商名称' },
                // extraParams: {
                //     businessTypeList: [STORAGE_NUM, LOAD_AND_UNLOAD_NUM],
                //     corporateType: LEASING_STORAGE_NUM, // TODO
                // },
                advanceUrl: `/supplier/supplierInfo/queryList`,
                prefix: 'api-srm-web',
                method: 'post',
                notFetchOnShow: true,
                queryConditionRequired: true,
                unfold: true,
                span: 4,
            },
            {
                ...companyAdvanceConfig,
                unfold: true,
                span: 4,
            },
            {
                ...siteAdvanceConfig,
                unfold: true,
                span: 4,
            },
            {
                name: '经营中心',
                value: 'centerName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                ...logicalWhAdvanceConfig,
                extraParams: { cdwhIsStop: '0' },
                multiple: true,
                multipleTableColumn: { prop: 'cdwhName', value: '逻辑仓名称' },
                unfold: true,
                span: 4,
            },
            {
                name: '考核分类',
                value: 'assessmentCategoryList',
                type: 'select',
                multiple: true,
                optionNum: 'SRM_ASSESSMENT_CATEGORY',
                unfold: true,
                span: 3,
            },
            {
                name: '创建人',
                value: 'createUserName',
                type: 'input',
                unfold: true,
                span: 2,
            },
            {
                name: '数据范围',
                value: 'dataSource',
                type: 'select',
                optionNum: 'SRM_EXCEPTION_DATA_SOURCE',
                unfold: true,
                span: 2,
            },
            {
                name: '仲裁单号',
                value: 'amsId',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '一级分类',
                value: 'amsFirstAbnormalCodeList',
                type: 'select',
                multiple: true,
                optionNum: 'AMS_FIRST_PROBLEM_V2',
                unfold: true,
                span: 3,
            },
            {
                name: '二级分类',
                value: 'amsSecondAbnormalCodeList',
                type: 'select',
                multiple: true,
                optionNum: 'AMS_SECOND_PROBLEM_V2',
                unfold: true,
                span: 3,
            },
            {
                name: '创建时间',
                value: 'createTimeArr',
                type: 'time',
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间',
                timeNum: 90,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(6, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(30, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const start = dayjs().startOf('day').subtract(90, 'd').toDate()
                                const end = dayjs().endOf('day').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                    ],
                },
                unfold: true,
                span: 6,
            },
        ],
        unfoldState: false,
        advancedBtn: false,
    },
    lspSearchList: {
        searchTxt: [
            {
                name: '月份',
                value: 'assessmentMonthList',
                type: 'time',
                timeType: 'monthrange',
                format: 'yyyy-MM',
                startPlaceholder: '开始月份',
                endPlaceholder: '结束月份',
                unfold: true,
                span: 5,
            },
            {
                ...logicalWhAdvanceConfig,
                multiple: true,
                multipleTableColumn: { prop: 'cdwhName', value: '逻辑仓名称' },
                unfold: true,
                span: 4,
            },
            {
                name: '考核分类',
                value: 'assessmentCategoryList',
                type: 'select',
                multiple: true,
                optionNum: 'SRM_ASSESSMENT_CATEGORY',
                unfold: true,
                span: 4,
            },
            {
                name: '考核事项',
                value: 'assessmentItem',
                type: 'input',
                unfold: true,
                span: 4,
            },
            {
                name: '仲裁单号',
                value: 'amsId',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '一级分类',
                value: 'amsFirstAbnormalCodeList',
                type: 'select',
                multiple: true,
                optionNum: 'AMS_FIRST_PROBLEM_V2',
                unfold: true,
                span: 3,
            },
            {
                name: '二级分类',
                value: 'amsSecondAbnormalCodeList',
                type: 'select',
                multiple: true,
                optionNum: 'AMS_SECOND_PROBLEM_V2',
                unfold: true,
                span: 3,
            },
        ],
        unfoldState: false,
        advancedBtn: false,
    },
    table: {
        // switchType: true,
        // tableCut: false,
        // clickState: false,
        // selectBtn: true,
        height: 'calc(100vh - 260px)',
        lspHeight: 'calc(100vh - 222px)',
        columns: [
            {
                label: '考核月份',
                prop: 'assessmentMonth',
                width: '100px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '170px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '140px',
            },
            {
                label: '经营中心',
                prop: 'centerName',
                width: '160px',
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: '140px',
            },
            {
                label: '逻辑仓',
                prop: 'logicalWarehouseName',
                width: '200px',
            },
            {
                label: '业务类型',
                prop: 'businessType',
                type: 'select',
                optionNum: 'SRM_BUSYNESS_TYPE_BACKGROUND',
                width: '100px',
            },
            {
                label: '合作方式',
                prop: 'corporateType',
                type: 'select',
                optionNum: 'SU_CORPORATE_TYPE',
                width: '100px',
            },
            {
                label: '考核分类',
                prop: 'assessmentCategory',
                type: 'select',
                optionNum: 'SRM_ASSESSMENT_CATEGORY',
                width: '100px',
            },
            {
                label: '考核事项',
                prop: 'assessmentItem',
                width: '100px',
            },
            {
                label: '考核标准',
                prop: 'assessmentStandard',
                width: '100px',
            },
            {
                label: '考核分值（分）',
                prop: 'assessmentScore',
                width: '120px',
            },
            {
                label: '实际金额(元)',
                prop: 'actualAmount',
                width: '100px',
            },
            {
                label: '备注说明',
                prop: 'remark',
                width: '150px',
            },
            {
                label: '附件',
                prop: 'attachmentUrl',
                type: 'buttonList',
                buttonList: ['查看'],
                // buttonList: ['查看', '下载'],
                width: '60px',
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '100px',
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: '160px',
            },
            {
                label: '数据来源',
                prop: 'dataSource',
                type: 'select',
                optionNum: 'SRM_EXCEPTION_DATA_SOURCE',
                width: '80px',
            },
            {
                label: '一级分类',
                prop: 'amsFirstAbnormalCode',
                type: 'select',
                optionNum: 'AMS_FIRST_PROBLEM_V2',
                width: '120px',
            },
            {
                label: '二级分类',
                prop: 'amsSecondAbnormalCode',
                type: 'select',
                optionNum: 'AMS_SECOND_PROBLEM_V2',
                width: '120px',
            },
            {
                label: '仲裁单号',
                prop: 'amsId',
                width: '180px',
            },
        ],
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
